import React, { useEffect, useState } from "react";
import SEO from "../shared/seo";
import Layout from "../components/organisms/layout/layout";
import { ReferenciaContenido } from "../interfaces/ReferenciaContenido";
import LibraryComponents from "../components/templates/library-components/libraryComponents";
import { getEntryDeliveryApi } from "../services/CMS.js";
import { getInsideInfo } from "../services/contentful";

const TemplateOne = (props: any) => {
  const [pageData, setPageContext] = useState<any>({});

  useEffect(() => {
    const getPageContext = async () => {
      let dataCont: any = await getEntryDeliveryApi(props.pageContext.contentful_id);
      dataCont.referenciaCabeceraBibliotecas = await getInsideInfo(dataCont.referenciaCabeceraBibliotecas);
      dataCont.referenciaContenido = await getInsideInfo(dataCont.referenciaContenido);
      for (let idx = 0; idx < dataCont.referenciaCabeceraBibliotecas.length; idx++) {
        dataCont.referenciaCabeceraBibliotecas[idx].migaDePan = props.pageContext.referenciaCabeceraBibliotecas[0].migaDePan;
      }
      setPageContext(dataCont);
    }
    getPageContext();
  }, []);

  // const pageContext: any = props.pageContext;
  const keyName = pageData.referenciaCabeceraBibliotecas && pageData.referenciaCabeceraBibliotecas[0].tipoCabecera;
  const pageSlug = props.location.pathname;

  return (
    <Layout
      hideHeaderDesktop={true}
      hideHeaderMobile={true}
      isNotRoot={true}
      headboard={pageData.referenciaCabeceraBibliotecas && pageData.referenciaCabeceraBibliotecas}
    >
      <SEO
        title={props.pageContext.metaTitulo || props.pageContext.nombreCategoria}
        slug={pageSlug}
        description={
          props.pageContext.metaDescripcion &&
          JSON.parse(props.pageContext.metaDescripcion.raw).content[0].content[0].value
        }
        image={
          props.pageContext.referenciaCabeceraBibliotecas[0].imagenHeader &&
          props.pageContext.referenciaCabeceraBibliotecas[0].imagenHeader.file.url
        }
        lang="es"
      />
      {pageData.referenciaContenido && pageData.referenciaContenido.map(
        (value: ReferenciaContenido, index: number) => (
          <div key={index} className={keyName} id={`${keyName}${index}`}>
            <LibraryComponents
              content={value}
              categoryName={pageData.nombreCategoria}
            />
          </div>
        )
      )}
    </Layout>
  );
};

export default TemplateOne;
